module.exports = __webpack_public_path__ + "img/guante-8.a3b8d923.jpg";